import React from "react";
import { useTranslation } from "react-i18next";
import { FilterSingleSelect } from "@/components/common/FilterSingleSelect";

export interface RatingFilterProps {
  rating: string;
  onChange: (rating: string) => void;
  placeholder?: string;
}

const RatingFilter: React.FC<RatingFilterProps> = ({
  rating,
  onChange,
  placeholder,
}) => {
  const { t } = useTranslation();
  const ratingOptions = [1, 2, 3, 4, 5].map((value) => ({
    value: value.toString(),
    label: t("feedbacks.filters.ratingOption", {
      count: value,
      defaultValue: "{{count}} min. rating",
    }),
  }));

  return (
    <FilterSingleSelect
      className="w-[150px] justify-between"
      options={ratingOptions}
      value={rating}
      onValueChange={onChange}
      placeholder={
        placeholder ??
        t(
          "feedbacks.filters.minimumRating",
          "Filter feedbacks by minimum rating",
        )
      }
    />
  );
};

export default RatingFilter;
